import * as types from './types';

function setCarrierContactContent(data, locale) {
    return {
        meta: locale,
        payload: data,
        type: types.SET_CARRIER_CONTACT_CONTENT,
    };
}

export {
    setCarrierContactContent,
};

export default {
    setCarrierContactContent,
};
